import QRCode from 'qrcode';

const getCleanUrl = (companyId) => {
  // FIKSET: Bruker nå ren URL (uten #) slik brukeren ba om
  // Dette krever at serveren har redirect fra /s/* til /#/s/* eller tilsvarende
  return `${window.location.origin}/s/${encodeURIComponent(companyId)}`;
};

export const generateQRCode = async (companyId, options = {}) => {
  try {
    if (!companyId) throw new Error('Mangler bedrifts-ID');
    const url = getCleanUrl(companyId);
    
    const qrOptions = {
      width: options.width || 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF',
      },
      errorCorrectionLevel: options.errorCorrectionLevel || 'M',
      ...options
    };

    const dataUrl = await QRCode.toDataURL(url, qrOptions);
    return { success: true, dataUrl, url, options: qrOptions };
  } catch (error) {
    console.error('Error generating QR code:', error);
    return { success: false, error: error.message };
  }
};

export const generateBrandedQRCode = async (companyId, branding, options = {}) => {
  try {
    const url = getCleanUrl(companyId);
    const size = options.width || 300;
    
    // Default options for branded QR
    const qrOptions = {
      width: size,
      margin: 1,
      color: {
        dark: branding.primaryColor || '#000000',
        light: '#FFFFFF',
      },
      errorCorrectionLevel: 'H' // High error correction for logo
    };

    const qrDataUrl = await QRCode.toDataURL(url, qrOptions);
    
    // Logo URL check
    const logoUrl = branding.logo || branding.logoUrl;
    
    // If no logo, return basic QR
    if (!logoUrl) {
      return { success: true, dataUrl: qrDataUrl, url };
    }

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');

    // Load QR
    const qrImage = new Image();
    await new Promise(resolve => {
      qrImage.onload = resolve;
      qrImage.src = qrDataUrl;
    });
    ctx.drawImage(qrImage, 0, 0, size, size);

    // Load Logo
    try {
      const logoImage = new Image();
      logoImage.crossOrigin = "Anonymous";
      await new Promise((resolve, reject) => {
        logoImage.onload = resolve;
        logoImage.onerror = reject;
        logoImage.src = logoUrl;
      });

      // Draw logo in center
      const logoSize = size * 0.2;
      const logoX = (size - logoSize) / 2;
      const logoY = (size - logoSize) / 2;

      // White background for logo to make it stand out
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(logoX, logoY, logoSize, logoSize);
      ctx.drawImage(logoImage, logoX, logoY, logoSize, logoSize);
    } catch (e) {
      console.warn("Could not load logo for QR code", e);
    }

    return { success: true, dataUrl: canvas.toDataURL('image/png'), url };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const downloadQRCode = async (companyId, companyName, options = {}) => {
  try {
    const result = await generateQRCode(companyId, options);
    if (!result.success) throw new Error(result.error);

    const link = document.createElement('a');
    const safeName = (companyName || 'bedrift').replace(/[^a-zA-Z0-9æøåÆØÅ \-]/g, '');
    link.download = `QR-Varsling-${safeName}.png`;
    link.href = result.dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const generateQRCodeWithInstructions = async (companyId, companyName, instructionText = 'Skann for å varsle trygt') => {
  try {
    const url = getCleanUrl(companyId);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    const qrSize = 300;
    const padding = 40;
    const textHeight = 140;
    
    canvas.width = qrSize + (padding * 2);
    canvas.height = qrSize + textHeight + (padding * 2);
    
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    const qrDataUrl = await QRCode.toDataURL(url, { width: qrSize, margin: 0 });
    const qrImage = new Image();
    await new Promise((resolve) => {
      qrImage.onload = resolve;
      qrImage.src = qrDataUrl;
    });
    
    ctx.drawImage(qrImage, padding, padding, qrSize, qrSize);
    
    ctx.fillStyle = '#111827';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(companyName || 'Varslingsportal', canvas.width / 2, qrSize + padding + 40);
    
    ctx.font = '16px Arial';
    ctx.fillStyle = '#4B5563';
    ctx.fillText(instructionText, canvas.width / 2, qrSize + padding + 70);
    
    ctx.font = '12px monospace';
    ctx.fillStyle = '#2563EB';
    ctx.fillText(window.location.hostname, canvas.width / 2, qrSize + padding + 100);
    
    return { success: true, dataUrl: canvas.toDataURL('image/png'), url };
  } catch (error) {
    return { success: false, error: error.message };
  }
};